// App-wide config for the Admin portal.

// Admin type that backs the internal Prosci admin portal.
// Mirrors the backend AuthenticationConstants::ADMIN_TYPE_PROSCI.
export const ADMIN_TYPE_PROSCI = 'prosci_admin' as const;

// Who can reach the Kaiya admin area.
// Mirrors the backend AuthenticationConstants::KAIYA_ADMIN_LEVELS.
//
// - Section (skills, golden docs, domains, terminology, dashboard, evals,
//   review queue, playground): super, admin, affiliate_admin
// - Agent Settings + Prompts: super only
export const KAIYA_SECTION_LEVELS = ['super', 'admin', 'affiliate_admin'] as const;
export const KAIYA_SUPER_LEVEL = 'super' as const;
